import React from "react";
import { ClipboardList, Construction } from "lucide-react";

/**
 * Placeholder for the Tender Report module (dashboard_restructure_spec §5.2.3).
 * Detailed layout to follow in a separate spec.
 */
export default function TenderReport() {
  return (
    <div className="space-y-8" data-testid="tender-report-page">
      <div className="flex items-end justify-between border-b border-ink-line pb-6">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-brand text-white grid place-items-center rounded-sm">
            <ClipboardList className="w-6 h-6" />
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-[0.2em] text-ink-muted">Reporting</div>
            <h1 className="font-display text-4xl font-bold tracking-tight mt-1">Tender Report</h1>
            <p className="text-sm text-ink-muted mt-1.5">Aggregate analytics across your entire tender portfolio.</p>
          </div>
        </div>
      </div>

      <div className="card-flat p-10 text-center">
        <Construction className="w-10 h-10 text-ink-muted mx-auto" />
        <div className="font-display text-2xl font-bold tracking-tight mt-4">Coming soon</div>
        <p className="text-sm text-ink-muted mt-2 max-w-md mx-auto leading-relaxed">
          Win/loss summaries, pipeline value over time, average framework scores, most-common root causes
          and a PDF export are being assembled. The Dashboard already surfaces the live operational KPIs.
        </p>
      </div>
    </div>
  );
}
